// import game1 from "../../../../assets/images/casino/TeenPatti.jpg";

import vivoAndarBahar from "../../assets/images/casino/vivoAndarBahar.jpg";
import vivoTeenPatti from "../../assets/images/casino/vivoTeenPatti.jpg";

import EZMarbleRaceMonaco from "../../assets/images/casino/EZMarbleRaceMonaco.webp";
import BetWithStreamers from "../../assets/images/casino/BetWithStreamers.webp";
import game1 from "../../assets/images/casino/TeenPatti.jpg";
import game2 from "../../assets/images/casino/betonteenpatti.jpg";
import game3 from "../../assets/images/casino/AndarBahar.jpg";
import game4 from "../../assets/images/casino/32Cards.jpg";
import game5 from "../../assets/images/casino/Roulette.jpg";
import game6 from "../../assets/images/casino/AkbarRomeoWalter.jpg";
import game7 from "../../assets/images/casino/Cricketwar.jpg";
import game8 from "../../assets/images/casino/Sicbo.jpg";
import game9 from "../../assets/images/casino/Baccarat.jpg";
import game10 from "../../assets/images/casino/WorliMatka.jpg";
import game11 from "../../assets/images/casino/DragonTiger.jpg";
import game12 from "../../assets/images/casino/OneDayTeenPatti.jpg";
import game13 from "../../assets/images/casino/KingRace.jpg";
import game14 from "../../assets/images/casino/CAsinoQueen.jpg";
import game15 from "../../assets/images/casino/ClassicAndarBahar.jpg";
import game16 from "../../assets/images/casino/Goa'sAndarBahar.jpg";
import game17 from "../../assets/images/casino/Lucky7.jpg";
import game18 from "../../assets/images/casino/Poker.jpg";
import game20 from "../../assets/images/casino/RNG3CardsJudgement.jpg";
import game21 from "../../assets/images/casino/RNG3-PlayerTeenPatti.jpg";
import game22 from "../../assets/images/casino/RNG32Cards.jpg";
import game23 from "../../assets/images/casino/RNGAkbarRomeoWalter.jpg";
import game24 from "../../assets/images/casino/RNGAndarBahar2020.jpg";
import game25 from "../../assets/images/casino/RNGBaccarat.jpg";
import game26 from "../../assets/images/casino/RNG-Baccarat-2020.jpg";
import game27 from "../../assets/images/casino/RNGCasinoQueen.jpg";
import game28 from "../../assets/images/casino/RNGCasinoQueen2020.jpg";
import game29 from "../../assets/images/casino/RNgCricket2020.jpg";
import game30 from "../../assets/images/casino/RNGDragonTiger.jpg";
import game31 from "../../assets/images/casino/RNGDragonTiger2020.jpg";
import game32 from "../../assets/images/casino/RNGJoker.jpg";
import game33 from "../../assets/images/casino/RNGKabutarFuddi.jpg";
import game34 from "../../assets/images/casino/RNGPoker.jpg";
import game35 from "../../assets/images/casino/RNGPoker2020.jpg";
import game36 from "../../assets/images/casino/RNGTeenPatti.jpg";
import game37 from "../../assets/images/casino/RNGTeenPatti2020.jpg";
import game38 from "../../assets/images/casino/TeenPattiFaceOff.jpg";

import populargame1 from "../../assets/images/casino/popular/oracle360roulette.jpg";
import populargame2 from "../../assets/images/casino/popular/frenchroulette.jpg";
import populargame3 from "../../assets/images/casino/popular/dragontigervivo.jpg";
import populargame4 from "../../assets/images/casino/popular/VABACCARAT1.jpg";
import populargame5 from "../../assets/images/casino/popular/lasvegasroulette.jpg";
import populargame6 from "../../assets/images/casino/popular/GonzosTreasureHunt.jpg";
import populargame7 from "../../assets/images/casino/popular/galaxybaccarat1.jpg";
import populargame8 from "../../assets/images/casino/popular/OttAndarBahar.jpg";
import populargame9 from "../../assets/images/casino/popular/Auto-Roulette.jpg";
import populargame10 from "../../assets/images/casino/popular/Auto-Cricket-Roulette.jpg";

import AuraGames1 from "../../assets/images/casino/aura/7Up7Down.jpg";
import AuraGames2 from "../../assets/images/casino/aura/32Cards.jpg";
import AuraGames3 from "../../assets/images/casino/aura/AndarBahar.jpg";
import AuraGames4 from "../../assets/images/casino/aura/DragonTiger.jpg";
import AuraGames5 from "../../assets/images/casino/aura/DreamCatcher.jpg";
import AuraGames6 from "../../assets/images/casino/aura/HighLow.jpg";
import AuraGames7 from "../../assets/images/casino/aura/Qween.jpg";
import AuraGames8 from "../../assets/images/casino/aura/Roulette.jpg";
import AuraGames9 from "../../assets/images/casino/aura/Sicbo.jpg";
import AuraGames10 from "../../assets/images/casino/aura/TeenPatti.jpg";

import Ezugi from "../../assets/images/provider/Ezugi-prvdr.jpg";
import EVOLUTION from "../../assets/images/provider/Evolution-prvdr.jpg";
import XPG from "../../assets/images/provider/XPG-prvdr.jpg";
import Supernowa from "../../assets/images/provider/Supernowa-prvdr.jpg";
import Vivo from "../../assets/images/provider/VivoGaming-prvdr.jpg";
import Slots from "../../assets/images/provider/Slots-prvdr.jpg";
import WorldCasino from "../../assets/images/provider/WorldCasino-prvdr.jpg";
import Qtech from "../../assets/images/provider/Qtech-prvdr.jpg";
import Onetouch from "../../assets/images/provider/Onetouch-prvdr.jpg";

export const gamesData = [
  {
    name: "Teen Patti Vivo",
    redirectUrl: "/casino/vivo-teen-patti",
    img: <img src={vivoTeenPatti} />,
  },
  {
    name: "Andar Bahar Vivo",
    redirectUrl: "/casino/vivo-andar-bahar",
    img: <img src={vivoAndarBahar} />,
  },
  {
    name: "Teen Patti",
    redirectUrl: "/casino/ezg-teen-patti-3-card",
    img: <img src={game1} />,
  },
  {
    name: "EZ Marble Race Monaco",
    redirectUrl: "/casino/ezg-ez-marble-race-monaco",
    img: <img src={EZMarbleRaceMonaco} />,
  },
  {
    name: "Bet With Streamers",
    redirectUrl: "/casino/ezg-bet-with-streamers",
    img: <img src={BetWithStreamers} />,
  },
  {
    name: "Bet on Teen Patti",
    redirectUrl: "/casino/ezg-bet-on-teen-patti",
    img: <img src={game2} />,
  },
  {
    name: "Andar Bahar",
    redirectUrl: "/casino/ezg-andar-bahar",
    img: <img src={game3} />,
  },
  {
    name: "32 Cards",
    redirectUrl: "/casino/ezg-32-cards",
    img: <img src={game4} />,
  },
  {
    name: "spanish roulette",
    redirectUrl: "/casino/ezg-spanish-roulette",
    img: <img src={game5} />,
  },
  {
    name: "akbar romeo walter",
    redirectUrl: "/casino/sn-akbar-romeo-walter",
    img: <img src={game6} />,
  },
  {
    name: "Cricket war",
    redirectUrl: "/casino/ezg-cricket-war",
    img: <img src={game7} />,
  },
  {
    name: "Sicbo",
    redirectUrl: "/casino/ezg-sic-bo",
    img: <img src={game8} />,
  },
  {
    name: "Baccarat",
    redirectUrl: "/casino/ezg-baccarat",
    img: <img src={game9} />,
  },
  {
    name: "Worli matka",
    redirectUrl: "/casino/sn-rng-worli-matka",
    img: <img src={game10} />,
  },
  {
    name: "Dragon tiger",
    redirectUrl: "/casino/ezg-dragon-tiger",
    img: <img src={game11} />,
  },
  {
    name: "One Day Teen patti",
    redirectUrl: "/casino/ezg-one-day-teen-patti",
    img: <img src={game12} />,
  },
  {
    name: "King race",
    redirectUrl: "/casino/sn-rng-king-race",
    img: <img src={game13} />,
  },
  {
    name: "Online Casino queen",
    redirectUrl: "/casino/sn-rng-casino-queen",
    img: <img src={game14} />,
  },
  {
    name: "Classic Andar bahar",
    redirectUrl: "/casino/sn-classic-andar-bahar",
    img: <img src={game15} />,
  },
  {
    name: "Goas Andar bahar",
    redirectUrl: "/casino/sn-goas-andar-bahar",
    img: <img src={game16} />,
  },
  {
    name: "Lucky 7",
    redirectUrl: "/casino/ezg-lucky-7",
    img: <img src={game17} />,
  },
  // {
  //   name: "3 cards judgement",
  //   redirectUrl: "/casino/sn-rng-3-cards-judgement",
  //   img: <img src={game20} />,
  // },
  {
    name: "Rng 3 player Teenpatti",
    redirectUrl: "/casino/sn-rng-3-player-teen-patti",
    img: <img src={game21} />,
  },
  {
    name: "32 cards",
    redirectUrl: "/casino/sn-rng-32-cards",
    img: <img src={game22} />,
  },
  {
    name: "Rng Akbar romeo walter",
    redirectUrl: "/casino/sn-rng-akbar-romeo-walter",
    img: <img src={game23} />,
  },
  {
    name: "Rng Baccarat",
    redirectUrl: "/casino/sn-rng-baccarat",
    img: <img src={game25} />,
  },
  {
    name: "Rng Casino queen",
    redirectUrl: "/casino/sn-rng-casino-queen",
    img: <img src={game27} />,
  },
  {
    name: "Rng Casino queen 2020",
    redirectUrl: "/casino/sn-rng-casino-queen-2020",
    img: <img src={game28} />,
  },
  // {
  //   name: "Cricket 2020",
  //   redirectUrl: "/casino/sn-rng-cricket-2020",
  //   img: <img src={game29} />,
  // },
  {
    name: "Rng dragon tiger",
    redirectUrl: "/casino/sn-rng-dragon-tiger",
    img: <img src={game30} />,
  },
  {
    name: "Rng dragon tiger 2020",
    redirectUrl: "/casino/sn-rng-dragon-tiger-2020",
    img: <img src={game31} />,
  },
  {
    name: "Rng Joker",
    redirectUrl: "/casino/sn-rng-joker",
    img: <img src={game32} />,
  },
  {
    name: "RNG Lucky 7",
    redirectUrl: "/casino/sn-rng-lucky-7",
    img: <img src={game33} />,
  },
  // {
  //   name: "poker",
  //   redirectUrl: "/casino/sn-rng-poker",
  //   img: <img src={game34} />,
  // },
  // {
  //   name: "poker 2020",
  //   redirectUrl: "/casino/sn-rng-poker-2020",
  //   img: <img src={game35} />,
  // },
  // {
  //   name: "Rng teen patti",
  //   redirectUrl: "/casino/sn-rng-teen-patti",
  //   img: <img src={game36} />,
  // },
  {
    name: "Rng teen patti 2020",
    redirectUrl: "/casino/sn-rng-teen-patti-2020",
    img: <img src={game37} />,
  },
  {
    name: "teen patti Face off",
    redirectUrl: "/casino/sn-teen-patti-face-off",
    img: <img src={game38} />,
  },
  {
    name: "Oracle 360 Roulette",
    redirectUrl: "/casino/vivo-oracle-360-roulette",
    img: <img src={populargame1} />,
  },
  {
    name: "French Roulette",
    redirectUrl: "/casino/vivo-french-roulette",
    img: <img src={populargame2} />,
  },
  {
    name: "Dragon Tiger Vivo",
    redirectUrl: "/casino/vivo-dragon-tiger",
    img: <img src={populargame3} />,
  },
  // {
  //   name: "VA Baccarat 1",
  //   redirectUrl: "/casino/vivo-va-bacarat-1",
  //   img: <img src={populargame4} />,
  // },
  {
    name: "Las Vegas Roulette",
    redirectUrl: "/casino/lasvegasroulette.jpg",
    img: <img src={populargame5} />,
  },
  {
    name: "gonzos quest megaways",
    redirectUrl: "/casino/ezgrt-gonzos-quest-megaways",
    img: <img src={populargame6} />,
  },
  {
    name: "Galaxy Baccarat 1",
    redirectUrl: "/casino/vivo-galaxy-baccarat-1",
    img: <img src={populargame7} />,
  },
  {
    name: "marina andar bahar",
    redirectUrl: "/casino/ezg-casino-marina-andar-bahar",
    img: <img src={populargame8} />,
  },
  {
    name: "Auto roulette",
    redirectUrl: "/casino/ezg-auto-roulette",
    img: <img src={populargame9} />,
  },
  {
    name: "Cricket Auto roulette",
    redirectUrl: "/casino/ezg-cricket-auto-roulette",
    img: <img src={populargame10} />,
  },
  {
    name: "7 Up Down",
    redirectUrl: "/casino/aura-7-up-down",
    img: <img src={AuraGames1} />,
  },
  // {
  //   name: "32 Cards",
  //   redirectUrl: "/casino/",
  //   img: <img src={AuraGames2} />,
  // },
  {
    name: "Andar Bahar",
    redirectUrl: "/casino/aura-andar-bahar",
    img: <img src={AuraGames3} />,
  },
  {
    name: "Dragon Tiger",
    redirectUrl: "/casino/aura-dragon-tiger",
    img: <img src={AuraGames4} />,
  },
  {
    name: "Dream Catcher",
    redirectUrl: "/casino/aura-dream-catcher",
    img: <img src={AuraGames5} />,
  },
  {
    name: "Hi Low",
    redirectUrl: "/casino/aura-hi-low",
    img: <img src={AuraGames6} />,
  },
  {
    name: "Queen Race",
    redirectUrl: "/casino/aura-queen-race",
    img: <img src={AuraGames7} />,
  },
  {
    name: "Roulette",
    redirectUrl: "/casino/aura-roulette",
    img: <img src={AuraGames8} />,
  },
  {
    name: "Sicbo",
    redirectUrl: "/casino/aura-sicbo",
    img: <img src={AuraGames9} />,
  },
  {
    name: "Teen Patti One Day",
    redirectUrl: "/casino/aura-teenpatti-1-Day",
    img: <img src={AuraGames10} />,
  },
];

export const providersData = [
  {
    name: "Ezugi",
    redirectUrl: "/casino/ezugi",
    img: <img src={Ezugi} />,
  },
  {
    name: "Evolution",
    redirectUrl: "/casino/evolution",
    img: <img src={EVOLUTION} />,
  },
  {
    name: "Xpg",
    redirectUrl: "/casino/xpg",
    img: <img src={XPG} />,
  },
  {
    name: "Supernowa",
    redirectUrl: "/casino/supernowa",
    img: <img src={Supernowa} />,
  },
  {
    name: "Vivo",
    redirectUrl: "/casino/vivo",
    img: <img src={Vivo} />,
  },
  {
    name: "Slots",
    redirectUrl: "/slots",
    img: <img src={Slots} />,
  },
  {
    name: "World Casino",
    redirectUrl: "/casino/worldcasino",
    img: <img src={WorldCasino} />,
  },
  {
    name: "Qtech",
    redirectUrl: "/casino/qtech",
    img: <img src={Qtech} />,
  },
];
